/**
 * @prettier
 * @author Alexander Nagelberg
 *
 **/
import React, { useRef } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { v4 as uuid } from 'uuid'

import { refundStatuses } from '../utils/refundUtils'

/**
 * Updates the URL with ?status=SELECTED_STATUS (defaults to Show All if URL isn't provided)
 *
 * @param {Object} prop
 * @param {boolean} prop.automatic - Whether to apply date automatically on change or user intervention
 *
 * @example
 * <StatusFilter automatic /> displays component with status drop down that changes URL when new status is selected
 *
 * <StatusFilter /> displays component with status drop down and a Submit button changing URL to status when clicked
 */
const StatusFilter = ({ automatic, updateFilter }) => {
  const { search, pathname } = useLocation()
  const history = useHistory()
  const query = new URLSearchParams(search)
  const statusRef = useRef()

  const applyFilter = () => {
    if (statusRef.current.value !== 'NONE') {
      // status xor date
      query.delete('to')
      query.delete('from')
      query.delete('failure')

      query.set('status', statusRef.current.value)
      history.push(`${pathname}?${query.toString()}`)
    }
  }

  const unique_id = 'StatusFilter' + uuid()

  return (
    <div className='lgy-funding-fee-status-filter'>
      <label for={unique_id}>Show:</label>
      <select
        id={unique_id}
        ref={statusRef}
        onChange={() => automatic && applyFilter}
        defaultValue={query.get('status') ?? 'NONE'}
      >
        <option value='NONE' disabled>
          -Select Status-
        </option>
        {Object.keys(refundStatuses).map(statusKey => (
          <option value={statusKey} key={statusKey}>
            {refundStatuses[statusKey]}
          </option>
        ))}
      </select>

      {!automatic && <button onClick={applyFilter}>Submit</button>}
    </div>
  )
}

export default StatusFilter
